var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00002 14.1643L13.2071 7.95716L11.7929 6.54296L7.00002 11.3359L2.20713 6.54296L0.792908 7.95716L7.00002 14.1643ZM7.00002 8.51436L13.2071 2.30728L11.7929 0.893066L7.00002 5.68596L2.20713 0.893066L0.792908 2.30728L7.00002 8.51436Z",
    fill: "#F8FAFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownVector);
export default __webpack_public_path__ + "static/media/down-vector.fc88a14454b4ec8aa64d48728656ab08.svg";
export { ForwardRef as ReactComponent };